export default __webpack_public_path__ + "static/media/exemplo-documentacao.d7c118d3.png";